export const lastTableRowThickBorder = {
  borderBottom: '3px solid #e0e0e0',
};

export const tableCellBold = {
  fontWeight: 'bold',
};

export const tableCellKey = {
  fontWeight: 'bold',
  width: 120,
};

export const listItemBlock = {
  display: 'block',
  pl: 0,
};